import React from "react";

const INDEX_DATA = [
  {
    title: "Indeksi seinän aluelämpötiloille",
    rows: [
      "97–100 % A kiitettävä",
      "93–96 % B erittäin hyvä",
      "89–92 % C hyvä",
      "85–88 % D tyydyttävä – lievästi riskialtis",
      "81–84 % E välttävä – riskialtis",
      "≤ 80 % F huono – erittäin riskialtis",
    ],
  },
  {
    title: "Indeksi lattian aluelämpötiloille",
    rows: [
      "100 % A kiitettävä",
      "99 % B erittäin hyvä",
      "97–98 % C hyvä",
      "95–96 % D tyydyttävä – lievästi riskialtis",
      "93–94 % E välttävä – riskialtis",
      "≤ 92 % F huono – erittäin riskialtis",
    ],
  },
  {
    title: "Indeksi pistemäisille vioille",
    rows: [
      "93–100 % A kiitettävä",
      "85–92 % B erittäin hyvä",
      "71–84 % C hyvä",
      "69–70 % D tyydyttävä – lievästi riskialtis",
      "61–68 % E välttävä – riskialtis",
      "≤ 61 % F huono – erittäin riskialtis",
    ],
  },
  {
    title: "Indeksi ikkunoiden, ovien ja läpivientien liitokset ja tiivistepinnat",
    rows: [
      "86–100 % A kiitettävä",
      "80–85 % B erittäin hyvä",
      "74–79 % C hyvä",
      "68–73 % D tyydyttävä – lievästi riskialtis",
      "62–67 % E välttävä – riskialtis",
      "≤ 61 % F huono – erittäin riskialtis",
    ],
  },
];

export default function LampotilaIndeksiBlock() {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "12px 20px",
        width: "100%",
      }}
    >
      {INDEX_DATA.map((table, index) => (
        <div key={index}>
          {/* Green heading */}
          <div
            style={{
              backgroundColor: "#04aa00",
              color: "#fff",
              fontWeight: "bold",
              padding: "5px 8px",
              fontSize: "14px",
              minHeight: "32px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {table.title}
          </div>

          {/* Rows */}
          <div>
            {table.rows.map((row, rowIndex) => (
              <div
                key={rowIndex}
                style={{
                  padding: "2px 8px",
                  fontSize: "13px",
                  fontWeight: "600",
                  borderBottom: "1px solid #555",
                  lineHeight: "1.15",
                }}
              >
                {row}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}